import moment from "moment";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { sentenceCase, statusColor } from "../../../../constants";
import { formatDateAtTime } from "../../../../utils";
import styles from "./styles.module.css";
import { ParagraphText } from "../../../../Libraries";
import { Box } from "@mui/material";
import { Fragment } from "react";

const OrderCalculation = ({ I18n, order }) => {
    const { delivery_charges, partner_markup, grand_total, tax_percent, total_tax, sub_total, discount, created_at_pkt_strftime, order_status, customer_name, payment_method, note } = order || {};

    return (
        <Box className={styles.orderDetailCalculationInnerBox}>
            <Box className={styles.orderDetailCalculationInnerRow}>
                <ParagraphText className="newFontColor fontSize14">{I18n.sub_total}</ParagraphText>
                <ParagraphText className="newFontColor fontSize17">Rs. {formatNum(sub_total)}</ParagraphText>
            </Box>
            <Box className={styles.orderDetailCalculationInnerRow}>
                <ParagraphText className="newFontColor fontSize14">{I18n.total_tax}</ParagraphText>
                <ParagraphText className="newFontColor fontSize17">
                    {total_tax ? <Fragment>
                        <span>Tax {tax_percent}%</span>
                        <span className="orderSeperator"></span>
                        <span>Rs. {formatNum(total_tax)}</span>
                    </Fragment> : "-"}
                </ParagraphText>
            </Box>
            <Box className={styles.orderDetailCalculationInnerRow}>
                <ParagraphText className="newFontColor fontSize14">{I18n.discount}</ParagraphText>
                <ParagraphText className="newFontColor fontSize17">{discount ? `Rs. ${formatNum(discount)}` : "-"}</ParagraphText>
            </Box>
            <Box className={styles.orderDetailCalculationInnerRow}>
                <ParagraphText className="newFontColor fontSize14">{I18n.delivery_charges}</ParagraphText>
                <ParagraphText className="newFontColor fontSize17">{delivery_charges ? `Rs. ${formatNum(delivery_charges)}` : "-"}</ParagraphText>
            </Box>

            <Box className={styles.orderDetailCalculationInnerRow}>
                <ParagraphText className="newFontColor fontSize14">{I18n.partner_markup}</ParagraphText>
                <ParagraphText className="newFontColor fontSize17">{partner_markup ? `Rs. ${formatNum(partner_markup)}` : "-"}</ParagraphText>
            </Box>
            <Box className={styles.borderTopSeperator}/>
            <Box className={`${styles.orderDetailCalculationInnerRow} `}>
                <ParagraphText className="newFontColor fontSize14 fontWeight500">{I18n.total_price}</ParagraphText>
                <ParagraphText className="newFontColor fontSize17 fontWeight500">
                    Rs. {formatNum(grand_total)}
                </ParagraphText>
            </Box>

            <Box className={styles.subHeader}>
                <ParagraphText className={"fontWeight500"}>{I18n.order_details}</ParagraphText>
            </Box>
            <Box className={styles.orderDetailCalculationInnerRow}>
                <ParagraphText className="newFontColor fontSize14">{I18n.date_and_time}</ParagraphText>
                <ParagraphText className="newFontColor fontSize17">{formatDateAtTime(moment(created_at_pkt_strftime))}</ParagraphText>
            </Box>
            <Box className={styles.orderDetailCalculationInnerRow}>
                <ParagraphText className="newFontColor fontSize14">{I18n.status}</ParagraphText>
                <ParagraphText className={`newFontColor fontSize17 ${statusColor[order_status]}`}>{sentenceCase(I18n[order_status])}</ParagraphText>
            </Box>
            <Box className={styles.orderDetailCalculationInnerRow}>
                <ParagraphText className="newFontColor fontSize14">{I18n.customer}</ParagraphText>
                <ParagraphText className="newFontColor fontSize17">{customer_name||"-"}</ParagraphText>
            </Box>
            <Box className={styles.orderDetailCalculationInnerRow}>
                <ParagraphText className="newFontColor fontSize14">{I18n.payment_method}</ParagraphText>
                <ParagraphText className="newFontColor fontSize17">{(payment_method || "-").toUpperCase()}</ParagraphText>
            </Box>
            <Box className={styles.orderDetailCalculationInnerRow}>
                <ParagraphText className="newFontColor fontSize14">{I18n.note}</ParagraphText>
                <ParagraphText className="newFontColor fontSize17">{(note || "-").toUpperCase()}</ParagraphText>
            </Box>



        </Box>
    );
};

export default OrderCalculation;
